export enum OrderStatus {
  Pending = 0,
  OrderSentToCompany,
  CompanyPreparingOrder,
  DriverOnWay,
  DriverArrived,
  OrderDelivered,
  OrderCanceled,
}
